import React from 'react';
import { PageSection, PageSectionVariants, EmptyState, EmptyStateBody, EmptyStateHeader } from '@patternfly/react-core';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';

import ContourCustomizationToolbar from '../customization/contour/ContourCustomizationToolbar';
import GlobalRoiCustomizationCollectionForm from './GlobalRoiCustomizationCollectionForm';
import FullRoiDetailsModal from '../customization/contour/FullRoiDetailsModal';
import { StoreState } from '../../store/store';
import { appConfigSelectors } from '../../store/appConfig/appConfigSlice';
import { configurationTargetSelectors } from '../../store/configurationTarget/configurationTargetSlice';
import { CustomizationObjectType, ModelType } from '../../store/global-types/customization-types';
import ModelTypeSupportCheck from '../../components/ModelTypeSupportCheck';

import './../customization/customization-page.css';

export const GLOBAL_TAB_ID = 'global';

const CustomizationPage = () => {

    const currentTarget = useSelector(configurationTargetSelectors.selectCurrent);
    const { t } = useTranslation();

    const customizationFetchError = useSelector((state: StoreState) => state.contouring.customizationFetchError);
    const appConfig = useSelector(appConfigSelectors.selectAppConfig);

    if (currentTarget === undefined) {
        return (
            <PageSection variant={PageSectionVariants.dark} padding={{ default: 'noPadding' }}>
                <EmptyState>
                    <EmptyStateHeader titleText={<>{t('selectConfigurationTarget.title')}</>} headingLevel="h4" />
                    <EmptyStateBody>{t('selectConfigurationTarget.message')}</EmptyStateBody>
                </EmptyState>
            </PageSection>
        );
    }

    return (
        <ModelTypeSupportCheck modelType={ModelType.Contouring}>
            {appConfig && appConfig.showErrorsInUi && customizationFetchError !== null ? (
                <PageSection variant={PageSectionVariants.light} className="selectable">
                    <EmptyState>
                        <EmptyStateHeader titleText="An error occurred" headingLevel="h4" />
                        <EmptyStateBody>
                        <Trans i18nKey="error.customizationFetchFailed" >
                                An error occurred when trying to load customization page: {{ customizationFetchError: customizationFetchError }}
                        </Trans>
                        </EmptyStateBody>
                    </EmptyState>
                </PageSection>
            ) : (
                <>
                    <PageSection variant={PageSectionVariants.light}>
                        <ContourCustomizationToolbar
                            currentView={CustomizationObjectType.GlobalRoi}
                            customizationOutputId={GLOBAL_TAB_ID}
                        />

                        <FullRoiDetailsModal />

                        <PageSection variant={PageSectionVariants.light}>
                            <GlobalRoiCustomizationCollectionForm />
                        </PageSection>

                    </PageSection>
                </>
            )}
        </ModelTypeSupportCheck>
    );
}

export default CustomizationPage;
